<section class="profile-wrapper">
  <app-profile-view *ngIf="urlPosition == '/account/profile'"></app-profile-view>
  <app-transaction-list-layout *ngIf="urlPosition == '/account/transaction'"></app-transaction-list-layout>
  <app-companies-following-component *ngIf="urlPosition == '/account/following'"></app-companies-following-component>
  <app-my-request-layout *ngIf="urlPosition == '/account/my-request'"></app-my-request-layout>
  <app-probo-portfolio  *ngIf="urlPosition == '/account/probo'"></app-probo-portfolio>
  <app-feeds-list-page *ngIf="urlPosition == '/account/posts'" [isFeed] = "false"></app-feeds-list-page>
</section>
